// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".demo-tabs>.el-tabs__content[data-v-0e740dfe]{padding:32px;color:#6b778c;font-size:32px;font-weight:600}.hbn-container[data-v-0e740dfe] .el-form-item .el-form-item__label{width:150px!important}.hbn-container[data-v-0e740dfe] .el-radio{min-width:90px}.hbn-container[data-v-0e740dfe] .el-radio__label{font-size:12px}.my-form-item[data-v-0e740dfe]{position:fixed;right:30px;z-index:999}", ""]);
// Exports
module.exports = exports;
